// Multivariate Dependencies
import { createStyles, makeStyles } from '@material-ui/core';
// Types
import { ColorTypes } from '../../types';
/**
 * @deprecated Do not use legacy components anymore.
 */
export var useStyles = makeStyles(function (theme) {
    return createStyles({
        link: function (_a) {
            var color = _a.color;
            return ({
                background: 'none',
                border: 'none',
                padding: 0,
                fontSize: theme.typography.fontSize,
                textDecoration: 'underline',
                cursor: 'pointer',
                outline: 'none',
                color: color === ColorTypes.Secondary ? theme.palette.secondary.main : theme.palette.primary.main,
            });
        },
        disabled: {
            color: theme.commonSettings.disabledColor,
        },
    });
});
//# sourceMappingURL=useStyles.js.map